export const validarCep = (value: string | undefined, required?: boolean) => {
    if (!value) return required == true ? false : true;
    const regex = /^\d{5}-\d{3}$/;
    return regex.test(value);
}